/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SILPriceProductValue } from './SILPriceProductValue';
import {
    SILPriceProductValueFromJSON,
    SILPriceProductValueFromJSONTyped,
    SILPriceProductValueToJSON,
} from './SILPriceProductValue';

/**
 * 
 * @export
 * @interface SILPriceProductInfo
 */
export interface SILPriceProductInfo {
    /**
     * 
     * @type {string}
     * @memberof SILPriceProductInfo
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductInfo
     */
    quantity?: number;
    /**
     * 
     * @type {Array<SILPriceProductValue>}
     * @memberof SILPriceProductInfo
     */
    validPrices?: Array<SILPriceProductValue>;
}

/**
 * Check if a given object implements the SILPriceProductInfo interface.
 */
export function instanceOfSILPriceProductInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SILPriceProductInfoFromJSON(json: any): SILPriceProductInfo {
    return SILPriceProductInfoFromJSONTyped(json, false);
}

export function SILPriceProductInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SILPriceProductInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'validPrices': !exists(json, 'validPrices') ? undefined : ((json['validPrices'] as Array<any>).map(SILPriceProductValueFromJSON)),
    };
}

export function SILPriceProductInfoToJSON(value?: SILPriceProductInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productId': value.productId,
        'quantity': value.quantity,
        'validPrices': value.validPrices === undefined ? undefined : ((value.validPrices as Array<any>).map(SILPriceProductValueToJSON)),
    };
}

